export default __webpack_public_path__ + "static/media/weddingButton.fef207c7.svg";